
























import { Component, namespace, mixins } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { IMeta } from '~/assets/interfaces/meta'
import MixinGeneral from '~/assets/mixins/general'
import ComponentProductItem1 from '~/components/products/product-item-1.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentLoadingDots from '~/components/loading/dots.vue'

const favouritesStore = namespace('favourites')

const pageStore = namespace('page')
@Component({
  watchQuery: ['page'],
  components: {
    ComponentPageContent,
    ComponentTypographyH1,
    ComponentLoadingDots,
    ComponentProductItem1,
  },
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
})
export default class pagePersonalIndex extends mixins(MixinGeneral) {
  @favouritesStore.State('items') items!: IFavouriteItem[]
  @favouritesStore.State('isLoading') private isLoading!: boolean
  @favouritesStore.State('isFirstLoaded') private isFirstLoaded!: boolean
  @favouritesStore.Getter('itemsQuantity') private itemsQuantity!: number

  private styleGrid!: IStyle
  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private styleMobileGrid!: IStyle

  private pages = 1

  private get classWrapper() {
    return {
      [this.$style.wrapper]: true,
      [this.styleMobileGrid.container]: this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private created(): void {
    this.setMeta({
      h1: 'Отложенные товары',
      title: 'Избранное',
    })
  }

  private styleSpacer!: IStyle
  private get classProductsList() {
    return {
      [this.styleSpacer.mbGutter2]: !this.$device.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.$device.isMobileOrTablet,
      [this.$style.productsList]: true,
    }
  }
}
